/* eslint-disable import/no-extraneous-dependencies */
import { setComponentMapOverrides } from '@jutro/uiconfig';
import SasriaFNOLWherePage from 'sasria-capability-fnol-common-react/Where/SasriaFNOLWherePage';
import SasriaPropertyIncident from 'sasria-capability-fnol-common-react/SasriaPropertyIncident/SasriaPropertyIncident';
import SasriaFNOLSummaryPage from 'sasria-capability-fnol-common-react/Summary/SasriaFNOLSummaryPage';
import DocumentsPage from 'gw-capability-fnol-common-react/pages/AdditionalInformation/AdditionalInformationPage';
import SasriaFNOLMONWizard from './SasriaFNOLMONWizard';

setComponentMapOverrides(
    {
        SasriaFNOLMONWizard: { component: 'SasriaFNOLMONWizard' },
        SasriaPropertyIncident: { component: 'SasriaPropertyIncident' },
        SasriaFNOLWherePage: { component: 'SasriaFNOLWherePage' },
        SasriaFNOLSummaryPage: { component: 'SasriaFNOLSummaryPage' },
        DocumentsPage: { component: 'DocumentsPage' }
    },
    {
        SasriaFNOLMONWizard,
        SasriaPropertyIncident,
        SasriaFNOLWherePage,
        SasriaFNOLSummaryPage,
        DocumentsPage
    }
);

export {
    SasriaFNOLMONWizard as default,
    SasriaPropertyIncident,
    SasriaFNOLWherePage,
    SasriaFNOLSummaryPage,
    DocumentsPage
};
